export default {"src":"/_next/static/image/public/images/flags/flag_421.97270963a4c35fd5f4c1de6cb753d714.svg","height":16,"width":24};